import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_FEE_CREDITS_ACTION_TYPE } from '../actions';

const initialState = {
  credits: [],
};

const loanFeeCreditsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case LOAN_FEE_CREDITS_ACTION_TYPE.GET_FEE_CREDITS:
        draft.credits = payload || initialState.credits;
        break;

      case LOAN_FEE_CREDITS_ACTION_TYPE.ADD_FEE_CREDIT:
        draft.credits = [...state.credits, payload];
        break;

      case LOAN_FEE_CREDITS_ACTION_TYPE.DELETE_FEE_CREDIT:
        draft.credits = state.credits.filter(
          credit => credit.loanFeeCreditId !== payload.feeCreditId,
        );
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default loanFeeCreditsReducer;
